import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import './web-app-components';
import AppBase from './web-app-components/components/AppBase';
import AuthProvider from './web-app-components/components/AuthProvider';

import 'mapbox-gl/dist/mapbox-gl.css';

import reportWebVitals from './reportWebVitals';

import App from './App';
import RouteBuyPage from './features/RouteBuyPage';
import InviteLandingPage from './features/InviteLandingPage';
import ForgotPasswordPage from './features/ForgotPasswordPage';
import UserProfile from './features/UserProfile';

function RedirectBuyToLt() {
  const location = useLocation();
  return (
    <Redirect
      to={{ pathname: '/lt-LT/buy', search: location.search, hash: location.hash }}
    />
  );
}

function RedirectInviteToLt() {
  const location = useLocation();
  return (
    <Redirect
      to={{ pathname: '/lt-LT/invite', search: location.search, hash: location.hash }}
    />
  );
}

function RedirectForgotPasswordToLt() {
  const location = useLocation();
  return (
    <Redirect
      to={{ pathname: '/lt-LT/forgot-password', search: location.search, hash: location.hash }}
    />
  );
}

function RedirectProfileToLt() {
  const location = useLocation();
  return (
    <Redirect
      to={{ pathname: '/lt-LT/profile', search: location.search, hash: location.hash }}
    />
  );
}

ReactDOM.render(
  <React.StrictMode>
    <AppBase>
      <AuthProvider>
        <SnackbarProvider
          maxSnack={1}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          <Router>
            <Switch>
              <Route path="/lt-LT/buy">
                <RouteBuyPage />
              </Route>
              <Route path="/en-EU/buy">
                <RouteBuyPage />
              </Route>
              <Route path="/lt-LT/invite">
                <InviteLandingPage />
              </Route>
              <Route path="/en-EU/invite">
                <InviteLandingPage />
              </Route>
              <Route path="/buy">
                <RedirectBuyToLt />
              </Route>
              <Route path="/invite">
                <RedirectInviteToLt />
              </Route>
              <Route path="/lt-LT/forgot-password">
                <ForgotPasswordPage />
              </Route>
              <Route path="/en-EU/forgot-password">
                <ForgotPasswordPage />
              </Route>
              <Route path="/forgot-password">
                <RedirectForgotPasswordToLt />
              </Route>
              <Route path="/lt-LT/profile">
                <UserProfile locale="lt-LT" />
              </Route>
              <Route path="/en-EU/profile">
                <UserProfile locale="en-EU" />
              </Route>
              <Route path="/profile">
                <RedirectProfileToLt />
              </Route>
              <Route path="*">
                <App />
              </Route>
            </Switch>
          </Router>
        </SnackbarProvider>
      </AuthProvider>
    </AppBase>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
